import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Clubs, Jobs } from "../../public/signup/club/club.model";
import { Athletes } from "../athlete/athlete.model";
import { Coachs, Teams } from "./club.model";
import { Categories } from "../catalogs/catalogs.model";

@Injectable({ providedIn: 'root' })
export class ClubService {

    constructor(private http: HttpClient) { }

    async findJobsTitles(): Promise<Jobs[]> {
        return <Jobs[]>await this.http.get(environment.urlApi.concat('/clubs/job-titles')).toPromise();
    }

    async findClub(id: number) {
        return await this.http.get(environment.urlApi.concat('/clubs/' + id)).toPromise();
    }

    async findClubs(sport: number, country: number, state?: string, sportGroup?:number) {
        let params = new HttpParams();
        if(sport){  params = params.set('sport', sport.toString()); }
        else if (sportGroup) { params = params.set('sportGroup', sportGroup.toString()); }
        params = params.set('country', country.toString());
        if (state) {
            params = params.set('state', state.toString());
        }
        return <Clubs[]>await this.http.get(environment.urlApi.concat('/clubs'), { params: params }).toPromise();
    }

    async findCategorysClub(sport: number, idClub: number): Promise<Categories[]> {
      let params = new HttpParams();
        params = params.set('sport', sport.toString());
        return <Categories[]>await this.http.get(environment.urlApi.concat('/clubs/'+ idClub +'/categories'),{params: params}).toPromise();
    }

    async findTeamsCategoryClub(sport: number, idClub: number, idCategory?: number): Promise<Teams[]> {
        let params = new HttpParams();
        params = params.set('sport', sport.toString());
        if (idCategory) { params = params.set('category', idCategory.toString()); }
        return <Teams[]>await this.http.get(environment.urlApi.concat('/clubs/' + idClub + '/teams'), { params: params }).toPromise();
    }

    async findAthletesTeamsClub(idClub: number, idTeam: number): Promise<Athletes[]> {
        return <Athletes[]>await this.http.get(environment.urlApi.concat('/clubs/' + idClub + '/teams/' + idTeam + '/athletes')).toPromise();
    }

    uploadClubProfileInfo(profileDesc: string) {
        let body = { profileDesc: profileDesc };
        return this.http.post(environment.urlApi.concat('/clubs/staff/profile/info'), body);
    }

    saveClubInfo(idClub: number, athletesRange: string, certified = false, city: string, state: Object, street: string, suite: string, workers: number, zipCode: number) {

        let body: any = {
            athletesRange: athletesRange,
            certified: certified,
            workers: +workers,
            address: {
                state: state,
                city: city,
                street: street,
                zipCode: +zipCode,
            }
        };


        if (suite) body.suite = suite;
        return this.http.put(environment.urlApi.concat('/clubs/' + idClub + '/info'), body);
    }

    createTeamInClub(data: { idClub: number, teamName: string, category: Object, firstTeam: boolean, isCoach?: boolean, joinTeam?: boolean, idCouch?: number}) {
        let body: any = {
            name: data.teamName,
            category: data.category,
        };

        if ((data.firstTeam && data.joinTeam && data.idCouch) || (!data.firstTeam && data.joinTeam && data.idCouch)) body.coaches = [{ id: data.idCouch }];
        let team = '';
        if (data.firstTeam) { team = '/init-team' }
        else if (data.isCoach) { team = '/team-coach'; delete body.coaches; }
        else if (!data.isCoach || (data.idCouch && data.joinTeam)) { team = '/team' }
        return this.http.put(environment.urlApi.concat('/clubs/' + data.idClub + team), body, {
            observe: 'response'
        });
    }

    async getLogoClub(idClub) {
        return await this.http.get(environment.urlApi.concat('/clubs/' + idClub + '/logo'), { responseType: 'blob' as 'json' }).toPromise();;
    }

    async findCoachesClub(clubId: number) {
        return this.http.get(environment.urlApi.concat('/clubs/' + clubId + '/coaches')).toPromise();
    }

    async findTeamsClub(clubId: number, sport?: number) {
      let params = new HttpParams();
      if(sport){  params = params.set('sport', sport.toString()); }
      return this.http.get(environment.urlApi.concat('/clubs/' + clubId + '/teams'), {params: params}).toPromise();
    }

    async findClubCoachs(clubId: number): Promise<Coachs[]> {
        return <Coachs[]>await this.http.get(environment.urlApi.concat('/clubs/' + clubId + '/coaches/available')).toPromise();
    }

    updateClubTeamCoach(clubId: number, teamId: number, body) {
        return this.http.post(environment.urlApi.concat('/clubs/' + clubId + '/teams/' + teamId + '/coaches'), body);
    }

    // Asociar Coach del club
    addClubCoach(clubId: number, coachId: number) {
        return this.http.put(environment.urlApi.concat('/clubs/' + clubId + '/coaches/' + coachId), {}).toPromise();
    }

    // Desasociar del club
    removeClubCoach(clubId: number, coachId: number) {
        return this.http.delete(environment.urlApi.concat('/clubs/' + clubId + '/coaches/' + coachId)).toPromise();
    }

    // Desasociar de un team
    removeTeamCoach(clubId: number, teamId: number, coachId: number) {
        return this.http.delete(environment.urlApi.concat('/clubs/' + clubId + '/teams/' + teamId + '/coaches/' + coachId)).toPromise();
    }

    async findFreeCoachesClub() {
        return this.http.get(environment.urlApi.concat('/clubs/coaches/available')).toPromise();
    }

}
